import React from 'react'
import { Card, CardBody, Col, Input, InputGroup, InputGroupText } from "reactstrap";
import CommonCardHeader from '../../../../../Utils/CommonComponents/CommonCardHeader';
import { FirstAndLastName, MultipleInputsTitle } from '../../../../../Utils/Constants';
import { multipleInputsSubTitle } from '../../../../../Data/Forms/FormControlsData';

export default function MultipleInputs() {
    
    return (
        <Col md={6}>
            <Card>
                <CommonCardHeader headClass='pb-0' title={MultipleInputsTitle} subTitle={multipleInputsSubTitle} />
                <CardBody className="common-flex main-custom-form card-wrapper">
                    <InputGroup>
                        <InputGroupText>{FirstAndLastName}</InputGroupText>
                        <Input type="text" />
                        <Input type="text" />
                    </InputGroup>
                    <InputGroup>
                        <InputGroupText>{'$'}</InputGroupText>
                        <InputGroupText>{'0.00'}</InputGroupText>
                        <Input type="text" />
                    </InputGroup>
                    <InputGroup>
                        <Input type="text" />
                        <InputGroupText>{'$'}</InputGroupText>
                        <InputGroupText>{'0.00'}</InputGroupText>
                    </InputGroup>
                </CardBody>
            </Card>
        </Col>
    )
}
